'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosMicOff = function IoIosMicOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.8 37.5l-20.2-34.4 1.1-0.6 20.2 34.4z m-10.8-9.9c-3.4 0-6.2-2.9-6.2-6.5v-9.2l8.9 15.1c-0.8 0.3-1.8 0.6-2.7 0.6z m6.2-6.5c0 0.8-0.2 1.5-0.4 2.2l-10.6-18.3c1.1-1.6 2.8-2.5 4.8-2.5 3.4 0 6.2 3 6.2 6.6v12z m3.8 0.2c0 2.1-0.7 4.2-1.9 5.8l-0.8-1.3c0.9-1.3 1.4-2.8 1.4-4.5v-6.3h1.3v6.3z m-9.1 9.9v4.9h5.4v1.4h-12.6v-1.4h5.7v-4.9c-5.3-0.4-9.4-4.7-9.4-9.9v-6.3h1.5v6.3c0 4.6 3.9 8.5 8.6 8.5 1.3 0 2.6-0.3 3.7-0.9l0.7 1.3c-1.1 0.5-2.3 0.9-3.6 1z' })
        )
    );
};

exports.default = IoIosMicOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-mic-off.js
// module id = 2236
// module chunks = 0